export default {
  primary: {
    2: '#FAFCFC',
    4: '#F5F9F9',
    20: '#007A78',
    30: '#00615F',
    40: '#005250',
  },
  green: {
    10: '#E2FCE3',
    20: '#A7F2B7',
    30: '#67D695',
    40: '#339A72',
    50: '#136657',
    60: '#114D4D',
    darkCrunchyApple: '#03A978',
  },
  red: {
    10: '#FFEDE3',
    20: '#FFBCAB',
    30: '#FF7973',
    40: '#B73949',
    50: '#7A1633',
  },
  yellow: {
    10: '#FFFEEB',
    20: '#FFFDC3',
    30: '#FFFB9B',
    40: '#FFFA70',
    50: '#FFF70A',
  },
  blue: {
    10: '#F9FEFE',
    20: '#ECF9FC',
    30: '#DCEEF7',
    40: '#6E92B1',
    50: '#2A4976',
  },
  beige: {
    10: '#FDFAF7',
    20: '#FBF7F4',
    30: '#F9F3F0',
    40: '#D6B9AF',
    50: '#B38478',
  },
  neutrals: {
    10: '#FFFFFF',
    20: '#F4F6F6',
    30: '#DEE3E3',
    40: '#C8D0D0',
    50: '#A8B3B3',
    60: '#859494',
    70: '#5F6D6D',
    80: '#252D2D',
  },
};
